(function () {
  // Stateless updater: re-query current roots every time to survive cart rerenders
  async function updateAll() {
    const roots = document.querySelectorAll(".free-shipping-goal");

    if (!roots || roots.length === 0) {
      return;
    }

    const total = await fetchCartTotalCents();

    roots.forEach((root) => {
      const textEl = root.querySelector(".free-shipping-goal__text");
      const thresholdCents = parseInt(root.dataset.thresholdCents || "0", 10);
      const unmetTemplate =
        root.dataset.unmetTemplate ||
        "Add {{amount}} more to get free shipping.";
      const metTemplate =
        root.dataset.metTemplate || "You’ve qualified for free shipping!";
      const moneyFormat = root.dataset.moneyFormat || "${{amount}}";

      if (!thresholdCents || thresholdCents <= 0) {
        if (textEl) textEl.textContent = "";
        return;
      }

      const remaining = Math.max(thresholdCents - total, 0);
      const amt = formatMoney(moneyFormat, remaining);

      const setMessage = (el) => {
        if (remaining > 0) {
          el.textContent = unmetTemplate.replace("{{amount}}", amt);
          root.setAttribute("data-qualified", "false");
        } else {
          el.textContent = metTemplate;
          root.setAttribute("data-qualified", "true");
        }
      };

      if (textEl) {
        setMessage(textEl);
      } else if ("MutationObserver" in window) {
        // One-time observer to catch late-mounted span after section/cart rerenders
        const once = new MutationObserver((mutations, obs) => {
          const el = root.querySelector(".free-shipping-goal__text");
          if (el) {
            setMessage(el);
            obs.disconnect();
          }
        });
        once.observe(root, { childList: true, subtree: true });
      }
    });
  }

  // Money formatter that respects a few Shopify formats
  function formatMoney(moneyFormat, cents) {
    if (isNaN(cents)) cents = 0;
    const dollars = cents / 100;
    if (moneyFormat && moneyFormat.includes("{{amount}}")) {
      return moneyFormat.replace("{{amount}}", dollars.toFixed(2));
    }
    return `$${dollars.toFixed(2)}`;
  }

  async function fetchCartTotalCents() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });

      if (!res.ok) {
        throw new Error("Cart fetch failed");
      }

      const cart = await res.json();
      return cart.total_price || 0; // in cents
    } catch (e) {
      console.warn("[FreeShippingGoal] Could not fetch cart:", e);
      return 0;
    }
  }

  // Initial render
  document.addEventListener("DOMContentLoaded", updateAll);
  // Safety: also run once after load (covers modules/defer)
  window.addEventListener("load", updateAll);

  // Keep in sync with Dawn cart changes.
  // Dawn versions commonly dispatch custom events on cart changes; we’ll listen for a few.
  const events = [
    "cart:updated",
    "cart:change",
    "cart-update",
    "line-item:change",
  ];
  events.forEach((evt) =>
    document.addEventListener(evt, updateAll, { passive: true })
  );

  // Also handle Shopify section re-renders on the cart page
  [
    "shopify:section:load",
    "shopify:section:unload",
    "shopify:section:reorder",
    "shopify:section:select",
    "shopify:section:deselect",
  ].forEach((evt) => document.addEventListener(evt, updateAll));

  // Delegate quantity input changes on cart page
  document.addEventListener(
    "change",
    (e) => {
      const t = e.target;
      if (
        t &&
        (t.matches('input[name="updates[]"]') ||
          t.matches('input[name="updates"]') ||
          t.closest("quantity-input"))
      ) {
        // small delay to allow Dawn to process the change
        setTimeout(updateAll, 50);
      }
    },
    { passive: true }
  );

  // Observe the main cart container for DOM replacements on cart page
  const cartMain = document.querySelector(
    'cart-items, #main-cart-items, form[action*="/cart"]'
  );

  if (cartMain && "MutationObserver" in window) {
    const mo2 = new MutationObserver(() => updateAll());
    mo2.observe(cartMain, { childList: true, subtree: true });
  }

  // Fallback: observe the cart drawer contents and update when it changes
  const drawer = document.querySelector(
    "#CartDrawer, cart-drawer, .cart-drawer"
  );

  if (drawer && "MutationObserver" in window) {
    const mo = new MutationObserver(() => updateAll());
    mo.observe(drawer, { childList: true, subtree: true });
  }

  // Also update after add-to-cart responses (covers product pages)
  // Many ATC forms use fetch to /cart/add.js — hook global fetch as a light fallback.
  const nativeFetch = window.fetch;
  window.fetch = async function () {
    const res = await nativeFetch.apply(this, arguments);
    try {
      const url = arguments[0]?.toString?.() || "";
      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update")
      ) {
        // slight delay to let the cart drawer open/update
        setTimeout(updateAll, 150);
      }
    } catch (_) {}
    return res;
  };

  // Also hook XMLHttpRequest for themes that use XHR for cart changes
  if ("XMLHttpRequest" in window) {
    const OrigXHR = window.XMLHttpRequest;
    const open = OrigXHR.prototype.open;
    const send = OrigXHR.prototype.send;
    OrigXHR.prototype.open = function (method, url) {
      try {
        this.__cartURL = url?.toString?.() || String(url || "");
      } catch (_) {
        this.__cartURL = "";
      }
      return open.apply(this, arguments);
    };
    OrigXHR.prototype.send = function () {
      this.addEventListener("load", () => {
        try {
          const url = this.__cartURL || "";
          if (
            url.includes("/cart/add") ||
            url.includes("/cart/change") ||
            url.includes("/cart/update")
          ) {
            setTimeout(updateAll, 150);
          }
        } catch (_) {}
      });
      return send.apply(this, arguments);
    };
  }
})();
